import React, { useEffect } from 'react';
import Topbar from '../components/Header/Topbar';
import Navbar from '../components/Header/Navbar';
import Spinner from '../components/Spinner/Spinner';
import HeroCarousel from '../components/Carousel/HeroCarousel';
import Services from '../components/Services/Services';
import Products from '../components/Products/Products';
import BrandCarousel from '../components/Brands/BrandCarousel';
import Footer from '../components/Footer/Footer';
import BackToTop from '../components/BackToTop/BackToTop';
import SEO from '../components/SEO/SEO';

const Home = () => {
  useEffect(() => {
    // Hide spinner after load
    setTimeout(() => {
      const spinner = document.getElementById('spinner');
      if (spinner) {
        spinner.classList.remove('show');
      }
    }, 500);

    // Initialize WOW.js if available
    if (window.WOW) {
      new window.WOW().init();
    }
  }, []);

  return (
    <>
      <SEO 
        title="Galaxy Power System | Best Battery shop in Chidambaram"
        description="Galaxy Power System is the leading battery and power solutions provider in Chidambaram. Authorized dealer for Exide, Luminous, Amaron batteries and solar systems."
        keywords="battery shop chidambaram, car battery chidambaram, bike battery chidambaram, solar panel tamil nadu, exide battery dealer, luminous dealer"
        canonicalUrl="https://galaxypowersystems.com/"
      />
      <Spinner />
      <Topbar />
      <Navbar />
      <HeroCarousel />
      <Services />
      
      {/* Products Offer Section */}
      <div className="container-fluid bg-light py-3 py-lg-5">
        <div className="container">
          <div className="row g-4">
            <div className="col-12 col-lg-6 wow fadeInLeft" data-wow-delay="0.2s">
              <div className="d-flex align-items-center justify-content-between border bg-white rounded p-4">
                <div>
                  <img src="/assets/galaxy-power-solution-chidambaram.jpg" className="img-fluid w-100" alt="Galaxy Power Solution Chidambaram" />
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 wow fadeInRight" data-wow-delay="0.3s">
              <div className="d-flex align-items-center justify-content-between border bg-white rounded p-4">
                <div>
                  <img src="/assets/galaxy-power-solution-in-chidambaram.jpg" className="img-fluid" alt="Galaxy Power Solution in Chidambaram" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Products />
      <BrandCarousel />
      <Footer />
      
      {/* Use the React BackToTop component */}
      <BackToTop />
    </>
  );
};

export default Home;